import loadable from '@loadable/component';

/* eslint react-app/import/no-webpack-loader-syntax: off */
const ARROW_RIGHT = loadable(() => import('-!svg-react-loader!@assets/images/arrow-right.svg'));
const CHEVRON_RIGHT = loadable(() => import('-!svg-react-loader!@assets/images/chevron-right.svg'));
const CLOSE = loadable(() => import('-!svg-react-loader!@assets/images/close.svg'));
const CLOSE_SMALL = loadable(() => import('-!svg-react-loader!@assets/images/close-small.svg'));
const CONTACT = loadable(() => import('-!svg-react-loader!@assets/images/contact.svg'));
const ELLIPSE = loadable(() => import('-!svg-react-loader!@assets/images/ellipse.svg'));
const EXTERNAL_LINK = loadable(() => import('-!svg-react-loader!@assets/images/external-link.svg'));
const EXTERNAL_LINK_LARGE = loadable(() => import('-!svg-react-loader!@assets/images/external-link-large.svg'));
const EXTERNAL_LINK_BLUE = loadable(() => import('-!svg-react-loader!@assets/images/external-link-blue.svg'));
const EXTERNAL_LINK_PINK = loadable(() => import('-!svg-react-loader!@assets/images/external-link-pink.svg'));
const FACEBOOK = loadable(() => import('-!svg-react-loader!@assets/images/facebook.svg'));
const FILTER = loadable(() => import('-!svg-react-loader!@assets/images/filter.svg'));
const INFO = loadable(() => import('-!svg-react-loader!@assets/images/info.svg'));
const INFO_BLUE = loadable(() => import('-!svg-react-loader!@assets/images/info-blue.svg'));
const INFO_FILL = loadable(() => import('-!svg-react-loader!@assets/images/info-fill.svg'));
const INSTAGRAM = loadable(() => import('-!svg-react-loader!@assets/images/instagram.svg'));
const LINKEDIN = loadable(() => import('-!svg-react-loader!@assets/images/linkedin.svg'));
const LIST = loadable(() => import('-!svg-react-loader!@assets/images/list.svg'));
const LIST_ALT = loadable(() => import('-!svg-react-loader!@assets/images/list-alt.svg'));
const LIST_BLUE = loadable(() => import('-!svg-react-loader!@assets/images/list-blue.svg'));
const LOGO = loadable(() => import('-!svg-react-loader!@assets/images/logo.svg'));
const MENU = loadable(() => import('-!svg-react-loader!@assets/images/menu.svg'));
const PHONE = loadable(() => import('-!svg-react-loader!@assets/images/phone.svg'));
const QUESTION_MARK = loadable(() => import('-!svg-react-loader!@assets/images/question-mark.svg'));
const SEARCH = loadable(() => import('-!svg-react-loader!@assets/images/search.svg'));
const DOCUMENT = loadable(() => import('-!svg-react-loader!@assets/images/document.svg'));
const SHARE = loadable(() => import('-!svg-react-loader!@assets/images/share.svg'));
const CHECK = loadable(() => import('-!svg-react-loader!@assets/images/check.svg'));
const PARTICLES = loadable(() => import('-!svg-react-loader!@assets/images/particles.svg'));
const THEMES = loadable(() => import('-!svg-react-loader!@assets/images/themes.svg'));
const TWITTER = loadable(() => import('-!svg-react-loader!@assets/images/twitter.svg'));

// Municipality icons
const AANMELDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Aanmelden.svg'));
const ACTUEEL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Actueel.svg'));
const AFVAL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Afval.svg'));
const AFVAL_GFT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalGFT.svg'));
const AFVAL_GLASCONTAINER = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/AfvalGlascontainer.svg')
);
const AFVAL_GROENBAK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalGroenbak.svg'));
const AFVAL_OPHALEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalOphalen.svg'));
const AFVAL_PMD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalPMD.svg'));
const AFVAL_SCHEIDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalScheiden.svg'));
const AFVALBAK_AFVALZAK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalbakAfvalzak.svg'));
const AFVALBAK_PMD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/AfvalbakPMD.svg'));
const AFVALCONTAINER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Afvalcontainer.svg'));
const AFVALCONTAINER_AFVALZAK = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/AfvalcontainerAfvalzak.svg')
);
const AFVALCONTAINERPAS = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Afvalcontainerpas.svg')
);
const AFVALKALENDER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Afvalkalender.svg'));
const AFVALZAK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Afvalzak.svg'));
const AGENDA = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Agenda.svg'));
const AIRBORNE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Airborne.svg'));
const ARMOEDE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Armoede.svg'));
const ASBEST_VERWIJDEREN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/AsbestVerwijderen.svg')
);
const ATTENTIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Attentie.svg'));
const AUTO = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Auto.svg'));
const BEDRIJVENTERREIN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Bedrijventerrein.svg'));
const BEGRAAFPLAATS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Begraafplaats.svg'));
const BEGROTING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Begroting.svg'));
const BELASTINGEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Belastingen.svg'));
const BETAALDATUMS_UITKERING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/BetaaldatumsUitkering.svg')
);
const BEVOLKING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Bevolking.svg'));
const BEVRIJDING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Bevrijding.svg'));
const BEZWAAR_EN_BEROEP = loadable(() => import('-!svg-react-loader!@assets/images/municipality/BezwaarEnBeroep.svg'));
const BIJSTANDSUITKERING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Bijstandsuitkering.svg')
);
const BLADEREN_OPRUIMEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/BladerenOpruimen.svg'));
const BOMEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Bomen.svg'));
const BOUWEN_EN_VERBOUWEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/BouwenEnVerbouwen.svg')
);
const BOUWPROJECTEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Bouwprojecten.svg'));
const BRANDGEVAAR = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Brandgevaar.svg'));
const BRIEF = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Brief.svg'));
const BUITENGEBIED = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Buitengebied.svg'));
const BURGEMEESTER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Burgemeester.svg'));
const CHAT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Chat.svg'));
const COMPUTER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Computer.svg'));
const COMPUTERREGELING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Computerregeling.svg'));
const CONTACT_GEMEENTE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ContactGemeente.svg'));
const CULTUUR = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Cultuur.svg'));
const DOCUMENTEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Documenten.svg'));
const DUURZAAMHEID = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Duurzaamheid.svg'));
const ECONOMIE_WERK_INKOMEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/EconomieWerkInkomen.svg')
);
const EENZAAMHEID = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Eenzaamheid.svg'));
const EIKENPROCESSIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Eikenprocessie.svg'));
const ELEKTRISCH_LADEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ElektrischLaden.svg'));
const ELEKTRISCH_RIJDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ElektrischRijden.svg'));
const ENERGIETRANSITIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Energietransitie.svg'));
const ENQUETE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Enquete.svg'));
const ERFGOED = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Erfgoed.svg'));
const ERFPACHT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Erfpacht.svg'));
const EVENEMENTEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Evenementen.svg'));
const F1 = loadable(() => import('-!svg-react-loader!@assets/images/municipality/F1.svg'));
const FIETS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Fiets.svg'));
const GEBOORTE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Geboorte.svg'));
const GEBRUIKER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Gebruiker.svg'));
const GEBRUIKER_CENTRAAL = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/GebruikerCentraal.svg')
);
const GEBRUIKER_INGELOGD = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/GebruikerIngelogd.svg')
);
const GEBRUIKERSVRAAG = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Gebruikersvraag.svg'));
const GEGEVENSWOORDENBOEK = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Gegevenswoordenboek.svg')
);
const GELD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Geld.svg'));
const GELUID = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Geluid.svg'));
const GEMEENTERAAD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Gemeenteraad.svg'));
const GEMEENTERAADVERGADERING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Gemeenteraadsvergadering.svg')
);
const GEMIVA_LOCATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/GemivaLocatie.svg'));
const GEZICHT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Gezicht.svg'));
const GLADHEID = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Gladheid.svg'));
const GRAFIEK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Grafiek.svg'));
const GROFVUIL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Grofvuil.svg'));
const HERDENKING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Herdenking.svg'));
const HOND = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Hond.svg'));
const HONDENBELASTING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Hondenbelasting.svg'));
const HOOG_WATER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/HoogWater.svg'));
const HOOGBOUW = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Hoogbouw.svg'));
const HORECA = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Horeca.svg'));
const HORECAVERGUNNINGEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Horecavergunningen.svg')
);
const HUIS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Huis.svg'));
const HUISENOMGEVING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/HuisEnOmgeving.svg'));
const HUISELIJK_GEWELD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/HuiselijkGeweld.svg'));
const HULP_HUISHOUDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/HulpHuishouden.svg'));
const HULPMIDDELEN_VINDEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/HulpmiddelenVinden.svg')
);
const IDKAART = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Idkaart.svg'));
const IN_EN_OM_UW_HUIS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/InEnOmUwHuis.svg'));
const INFORMATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Informatie.svg'));
const INFORMATIE_EN_BETALEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/InformatieEnBetalen.svg')
);
const INKOMEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Inkomen.svg'));
const INLOGGEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Inloggen.svg'));
const INSPRAAK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Inspraak.svg'));
const ISOLATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Isolatie.svg'));
const JEUGD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Jeugd.svg'));
const KENNIS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Kennis.svg'));
const KERSTBOMEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Kerstbomen.svg'));
const KIND_EN_FAMILIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/KindEnFamilie.svg'));
const KLACHT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Klacht.svg'));
const KONINGSDAG = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Koningsdag.svg'));
const KOPEN_EN_HUREN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/KopenEnHuren.svg'));
const KOPEN_EN_VERKOPEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/KopenEnVerkopen.svg'));
const LAAD_STATION = loadable(() => import('-!svg-react-loader!@assets/images/municipality/LaadStation.svg'));
const LEERLINGENVERVOER = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Leerlingenvervoer.svg')
);
const LET_OP = loadable(() => import('-!svg-react-loader!@assets/images/municipality/LetOp.svg'));
const LIEFDADIGHEID = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Liefdadigheid.svg'));
const LOCATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Locatie.svg'));
const MANEGE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Manege.svg'));
const MARKTGELDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Marktgelden.svg'));
const MEEUWENOVERLAST = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Meeuwenoverlast.svg'));
const MELDING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Melding.svg'));
const MELDING_OMGEVALLEN_BOOM = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/MeldingOmgevallenBoom.svg')
);
const MELDING_OPENBARE_RUIMTE = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/MeldingOpenbareRuimte.svg')
);
const MELDING_STRAATVERLICHTING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/MeldingStraatverlichting.svg')
);
const MILIEUZONE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Milieuzone.svg'));
const MOBILITEIT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Mobiliteit.svg'));
const MONITOR_AGROFOOD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/MonitorAgrofood.svg'));
const MONITOR_DUURZAAMHEID = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/MonitorDuurzaamheid.svg')
);
const MONITOR_SOCIAAL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/MonitorSociaal.svg'));
const MONITOR_VIRUS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/MonitorVirus.svg'));
const MONITOR_WONINGMARKT = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/MonitorWoningmarkt.svg')
);
const MONUMENT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Monument.svg'));
const MONUMENT_WONING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/MonumentWoning.svg'));
const MUSEUM = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Museum.svg'));
const NATUUR_LANDSCHAP = loadable(() => import('-!svg-react-loader!@assets/images/municipality/NatuurLandschap.svg'));
const NIEUWSBRIEF = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Nieuwsbrief.svg'));
const OMGEVING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Omgeving.svg'));
const OMGEVINGSVERGUNNING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Omgevingsvergunning.svg')
);
const OMGEVINGSVISIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Omgevingsvisie.svg'));
const OMGEVINGSVISIE_DOCUMENT = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/OmgevingsvisieDocument.svg')
);
const ONDERHOUD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Onderhoud.svg'));
const REGELING_LAAG_INKOMEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/RegelingLaagInkomen.svg')
);
const ZWEMMEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Zwemmen.svg'));
const ZWEMABONNEMENT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Zwemabonnement.svg'));
const ZOEKEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Zoeken.svg'));
const ZELFSTANDIG_WONEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ZelfstandigWonen.svg'));
const ZELFBEHEER_TEGEL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ZelfbeheerTegel.svg'));
const WOZ_WAARDE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/WozWaarde.svg'));
const WONING_ZOEKEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/WoningZoeken.svg'));
const WOLF = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Wolf.svg'));
const WMO = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Wmo.svg'));
const WINKELWAGEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Winkelwagen.svg'));
const WINKELEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Winkelen.svg'));
const WINDENERGIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Windenergie.svg'));
const WIJKTEAM = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Wijkteam.svg'));
const WIE_IS_WIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/WieIsWie.svg'));
const WERKZAAMHEDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Werkzaamheden.svg'));
const WELZIJNSWERK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Welzijnswerk.svg'));
const WANDELEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Wandelen.svg'));
const VUURWERK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Vuurwerk.svg'));
const VRIJWILLIGERSWERK = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Vrijwilligerswerk.svg')
);
const VOEDING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Voeding.svg'));
const VLUCHTELINGENOPVANG = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Vluchtelingenopvang.svg')
);
const VLAG = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Vlag.svg'));
const VIRUS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Virus.svg'));
const VERVOERSVOORZIENING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Vervoersvoorziening.svg')
);
const VERSLAVING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Verslaving.svg'));
const VERKIEZINGEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Verkiezingen.svg'));
const VERKEERSLICHT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Verkeerslicht.svg'));
const VERHUIZEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Verhuizen.svg'));
const VERGUNNING_ALGEMEEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/VergunningAlgemeen.svg')
);
const VERGOEDING_ENERGIEKOSTEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/VergoedingEnergiekosten.svg')
);
const VERGADEREN_DIGITAAL = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/VergaderenDigitaal.svg')
);
const VERGADEREN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Vergaderen.svg'));
const VEILIGE_WIJK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/VeiligeWijk.svg'));
const VEERBOOT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Veerboot.svg'));
const VACCINATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Vaccinatie.svg'));
const VACATURES = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Vacatures.svg'));
const UW_WIJK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/UwWijk.svg'));
const UW_GEMEENTE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/UwGemeente.svg'));
const UITTREKSEL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Uittreksel.svg'));
const TUINBOUW = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Tuinbouw.svg'));
const TROUWEN_EN_GEREGISTREERD_PARTNERSCHAP = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/TrouwenEnGeregistreerdPartnerschap.svg')
);
const TOESLAG = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Toeslag.svg'));
const TOEGANKELIJKHEID = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Toegankelijkheid.svg'));
const THUISWERKEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Thuiswerken.svg'));
const TEMPERATUUR_MELDING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/TemperatuurMelding.svg')
);
const SUBSIDIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Subsidie.svg'));
const STRAND = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Strand.svg'));
const STOOKVERBOD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Stookverbod.svg'));
const STATION_STOP_TREIN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/StationStoptrein.svg')
);
const STATION_SNEL_TREIN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/StationSneltrein.svg')
);
const SPORTKLEDING_MUZIEKINSTRUMENTEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/SportkledingMuziekinstrumenten.svg')
);
const SPORT_CULTURELE_ACTIVITEIT = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/SportCultureleActiviteit.svg')
);
const SPORT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Sport.svg'));
const SPEELTUIN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Speeltuin.svg'));
const SOCIAAL_ZORG_WELZIJN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/SociaalZorgWelzijn.svg')
);
const SINTERKLAAS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Sinterklaas.svg'));
const SCHOOLKOSTEN_REGELING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Schoolkostenregeling.svg')
);
const ROLSTOEL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Rolstoel.svg'));
const ROERENDE_ZAAK_BELASTING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/RoerendeZaakbelasting.svg')
);
const RIOOL_WERKZAAMHEDEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Rioolwerkzaamheden.svg')
);
const RIOOL_HEFFING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Rioolheffing.svg'));
const RIOOL = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Riool.svg'));
const RIJBEWIJS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Rijbewijs.svg'));
const RECREATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Recreatie.svg'));
const RECLAME_BELASTING = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Reclamebelasting.svg'));
const RECLAME = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Reclame.svg'));
const RAAD_EN_COLLEGE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/RaadEnCollege.svg'));
const PRIJSKAARTJE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Prijskaartje.svg'));
const PRESENTATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Presentatie.svg'));
const POLITIEK = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Politiek.svg'));
const PASPOORT_INTERNATIONAAL = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/PaspoortInternationaal.svg')
);
const PASPOORT_ID_KAART_GECOMBINEERD_INTERNATIONAAL = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/PaspoortIdkaartGecombineerdInternationaal.svg')
);
const PASPOORT_ID_KAART_GECOMBINEERD = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/PaspoortIdkaartGecombineerd.svg')
);
const PASPOORT = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Paspoort.svg'));
const PARTICIPATIE_UITVOERING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/ParticipatieUitvoering.svg')
);
const PARTICIPATIE_PLAN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ParticipatiePlan.svg'));
const PARTICIPATIE_PITCH = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/ParticipatiePitch.svg')
);
const PARTICIPATIE_LIKE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/ParticipatieLike.svg'));
const PARTICIPATIE_CHECKLIST = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/ParticipatieChecklist.svg')
);
const PARTICIPATIE_CAMPAGNE = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/ParticipatieCampagne.svg')
);
const PARTICIPATIE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Participatie.svg'));
const PARKEREN_BEDRIJVEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/ParkerenBedrijven.svg')
);
const PARKEREN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Parkeren.svg'));
const PARKEERVOORZIENING_GEHANDICAPTEN = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/ParkeervoorzieningGehandicapten.svg')
);
const PARKEERVERGUNNING = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Parkeervergunning.svg')
);
const PARKEERPLATTEGROND = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/Parkeerplattegrond.svg')
);
const PARKEERKOSTEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Parkeerkosten.svg'));
const OVERLIJDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Overlijden.svg'));
const OVER_DE_STAD = loadable(() => import('-!svg-react-loader!@assets/images/municipality/OverDeStad.svg'));
const OVER_DE_GEMEENTE = loadable(() => import('-!svg-react-loader!@assets/images/municipality/OverDeGemeente.svg'));
const OPENINGSTIJDEN_WINKELS = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/OpeningstijdenWinkels.svg')
);
const OPENINGSTIJDEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Openingstijden.svg'));
const ONTHEFFING_MILIEUZONE = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/OntheffingMilieuzone.svg')
);
const ONDERWIJS_VOORTGEZET = loadable(
  () => import('-!svg-react-loader!@assets/images/municipality/OnderwijsVoortgezet.svg')
);
const ONDERWIJS_HOGER = loadable(() => import('-!svg-react-loader!@assets/images/municipality/OnderwijsHoger.svg'));
const ONDERWIJS_BASIS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/OnderwijsBasis.svg'));
const ONDERWIJS = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Onderwijs.svg'));
const ONDERSCHEIDINGEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Onderscheidingen.svg'));
const ONDERNEMEN = loadable(() => import('-!svg-react-loader!@assets/images/municipality/Ondernemen.svg'));

export const VISUALS = {
  ARROW_RIGHT,
  CHEVRON_RIGHT,
  CLOSE,
  CLOSE_SMALL,
  CONTACT,
  DOCUMENT,
  ELLIPSE,
  EXTERNAL_LINK,
  EXTERNAL_LINK_LARGE,
  EXTERNAL_LINK_BLUE,
  EXTERNAL_LINK_PINK,
  FACEBOOK,
  FILTER,
  INFO,
  INFO_BLUE,
  INFO_FILL,
  INSTAGRAM,
  LINKEDIN,
  LIST,
  LIST_ALT,
  LIST_BLUE,
  LOGO,
  MENU,
  PHONE,
  QUESTION_MARK,
  SEARCH,
  SHARE,
  CHECK,
  PARTICLES,
  THEMES,
  TWITTER,
  // Municipality icons
  AANMELDEN,
  ACTUEEL,
  AFVAL,
  AFVAL_GFT,
  AFVAL_GLASCONTAINER,
  AFVAL_GROENBAK,
  AFVAL_OPHALEN,
  AFVAL_PMD,
  AFVAL_SCHEIDEN,
  AFVALBAK_AFVALZAK,
  AFVALBAK_PMD,
  AFVALCONTAINER,
  AFVALCONTAINER_AFVALZAK,
  AFVALCONTAINERPAS,
  AFVALKALENDER,
  AFVALZAK,
  AGENDA,
  AIRBORNE,
  ARMOEDE,
  ASBEST_VERWIJDEREN,
  ATTENTIE,
  AUTO,
  BEDRIJVENTERREIN,
  BEGRAAFPLAATS,
  BEGROTING,
  BELASTINGEN,
  BETAALDATUMS_UITKERING,
  BEVOLKING,
  BEVRIJDING,
  BEZWAAR_EN_BEROEP,
  BIJSTANDSUITKERING,
  BLADEREN_OPRUIMEN,
  BOMEN,
  BOUWEN_EN_VERBOUWEN,
  BOUWPROJECTEN,
  BRANDGEVAAR,
  BRIEF,
  BUITENGEBIED,
  BURGEMEESTER,
  CHAT,
  COMPUTER,
  COMPUTERREGELING,
  CONTACT_GEMEENTE,
  CULTUUR,
  DOCUMENTEN,
  DUURZAAMHEID,
  ECONOMIE_WERK_INKOMEN,
  EENZAAMHEID,
  EIKENPROCESSIE,
  ELEKTRISCH_LADEN,
  ELEKTRISCH_RIJDEN,
  ENERGIETRANSITIE,
  ENQUETE,
  ERFGOED,
  ERFPACHT,
  EVENEMENTEN,
  F1,
  FIETS,
  GEBOORTE,
  GEBRUIKER,
  GEBRUIKER_CENTRAAL,
  GEBRUIKER_INGELOGD,
  GEBRUIKERSVRAAG,
  GEGEVENSWOORDENBOEK,
  GELD,
  GELUID,
  GEMEENTERAAD,
  GEMEENTERAADVERGADERING,
  GEMIVA_LOCATIE,
  GEZICHT,
  GLADHEID,
  GRAFIEK,
  GROFVUIL,
  HERDENKING,
  HOND,
  HONDENBELASTING,
  HOOG_WATER,
  HOOGBOUW,
  HORECA,
  HORECAVERGUNNINGEN,
  HUIS,
  HUISENOMGEVING,
  HUISELIJK_GEWELD,
  HULP_HUISHOUDEN,
  HULPMIDDELEN_VINDEN,
  IDKAART,
  IN_EN_OM_UW_HUIS,
  INFORMATIE,
  INFORMATIE_EN_BETALEN,
  INKOMEN,
  INLOGGEN,
  INSPRAAK,
  ISOLATIE,
  JEUGD,
  KENNIS,
  KERSTBOMEN,
  KIND_EN_FAMILIE,
  KLACHT,
  KONINGSDAG,
  KOPEN_EN_HUREN,
  KOPEN_EN_VERKOPEN,
  LAAD_STATION,
  LEERLINGENVERVOER,
  LET_OP,
  LIEFDADIGHEID,
  LOCATIE,
  MANEGE,
  MARKTGELDEN,
  MEEUWENOVERLAST,
  MELDING,
  MELDING_OMGEVALLEN_BOOM,
  MELDING_OPENBARE_RUIMTE,
  MELDING_STRAATVERLICHTING,
  MILIEUZONE,
  MOBILITEIT,
  MONITOR_AGROFOOD,
  MONITOR_DUURZAAMHEID,
  MONITOR_SOCIAAL,
  MONITOR_VIRUS,
  MONITOR_WONINGMARKT,
  MONUMENT,
  MONUMENT_WONING,
  MUSEUM,
  NATUUR_LANDSCHAP,
  NIEUWSBRIEF,
  OMGEVING,
  OMGEVINGSVERGUNNING,
  OMGEVINGSVISIE,
  OMGEVINGSVISIE_DOCUMENT,
  ONDERHOUD,
  ONDERNEMEN,
  ONDERSCHEIDINGEN,
  ONDERWIJS,
  ONDERWIJS_BASIS,
  ONDERWIJS_HOGER,
  ONDERWIJS_VOORTGEZET,
  ONTHEFFING_MILIEUZONE,
  OPENINGSTIJDEN,
  OPENINGSTIJDEN_WINKELS,
  OVER_DE_GEMEENTE,
  OVER_DE_STAD,
  OVERLIJDEN,
  PARKEERKOSTEN,
  PARKEERPLATTEGROND,
  PARKEERVERGUNNING,
  PARKEERVOORZIENING_GEHANDICAPTEN,
  PARKEREN,
  PARKEREN_BEDRIJVEN,
  PARTICIPATIE,
  PARTICIPATIE_CAMPAGNE,
  PARTICIPATIE_CHECKLIST,
  PARTICIPATIE_LIKE,
  PARTICIPATIE_PITCH,
  PARTICIPATIE_PLAN,
  PARTICIPATIE_UITVOERING,
  PASPOORT,
  PASPOORT_ID_KAART_GECOMBINEERD,
  PASPOORT_ID_KAART_GECOMBINEERD_INTERNATIONAAL,
  PASPOORT_INTERNATIONAAL,
  POLITIEK,
  PRESENTATIE,
  PRIJSKAARTJE,
  RAAD_EN_COLLEGE,
  RECLAME,
  RECLAME_BELASTING,
  RECREATIE,
  REGELING_LAAG_INKOMEN,
  RIJBEWIJS,
  RIOOL,
  RIOOL_HEFFING,
  RIOOL_WERKZAAMHEDEN,
  ROERENDE_ZAAK_BELASTING,
  ROLSTOEL,
  SCHOOLKOSTEN_REGELING,
  SINTERKLAAS,
  SOCIAAL_ZORG_WELZIJN,
  SPEELTUIN,
  SPORT,
  SPORT_CULTURELE_ACTIVITEIT,
  SPORTKLEDING_MUZIEKINSTRUMENTEN,
  STATION_SNEL_TREIN,
  STATION_STOP_TREIN,
  STOOKVERBOD,
  STRAND,
  SUBSIDIE,
  TEMPERATUUR_MELDING,
  THUISWERKEN,
  TOEGANKELIJKHEID,
  TOESLAG,
  TROUWEN_EN_GEREGISTREERD_PARTNERSCHAP,
  TUINBOUW,
  UITTREKSEL,
  UW_GEMEENTE,
  UW_WIJK,
  VACATURES,
  VACCINATIE,
  VEERBOOT,
  VEILIGE_WIJK,
  VERGADEREN,
  VERGADEREN_DIGITAAL,
  VERGOEDING_ENERGIEKOSTEN,
  VERGUNNING_ALGEMEEN,
  VERHUIZEN,
  VERKEERSLICHT,
  VERKIEZINGEN,
  VERSLAVING,
  VERVOERSVOORZIENING,
  VIRUS,
  VLAG,
  VLUCHTELINGENOPVANG,
  VOEDING,
  VRIJWILLIGERSWERK,
  VUURWERK,
  WANDELEN,
  WELZIJNSWERK,
  WERKZAAMHEDEN,
  WIE_IS_WIE,
  WIJKTEAM,
  WINDENERGIE,
  WINKELEN,
  WINKELWAGEN,
  WMO,
  WOLF,
  WONING_ZOEKEN,
  WOZ_WAARDE,
  ZELFBEHEER_TEGEL,
  ZELFSTANDIG_WONEN,
  ZOEKEN,
  ZWEMABONNEMENT,
  ZWEMMEN,
};

export const ICON_MAPPING = {
  Aanmelden: 'AANMELDEN',
  Actueel: 'ACTUEEL',
  Afval: 'AFVAL',
  AfvalGFT: 'AFVAL_GFT',
  AfvalGlascontainer: 'AFVAL_GLASCONTAINER',
  AfvalGroenbak: 'AFVAL_GROENBAK',
  AfvalOphalen: 'AFVAL_OPHALEN',
  AfvalPMD: 'AFVAL_PMD',
  AfvalScheiden: 'AFVAL_SCHEIDEN',
  AfvalbakAfvalzak: 'AFVALBAK_AFVALZAK',
  AfvalbakPMD: 'AFVALBAK_PMD',
  Afvalcontainer: 'AFVALCONTAINER',
  AfvalcontainerAfvalzak: 'AFVALCONTAINER_AFVALZAK',
  Afvalcontainerpas: 'AFVALCONTAINERPAS',
  Afvalkalender: 'AFVALKALENDER',
  Afvalzak: 'AFVALZAK',
  Agenda: 'AGENDA',
  Airborne: 'AIRBORNE',
  Armoede: 'ARMOEDE',
  AsbestVerwijderen: 'ASBEST_VERWIJDEREN',
  Attentie: 'ATTENTIE',
  Auto: 'AUTO',
  Bedrijventerrein: 'BEDRIJVENTERREIN',
  Begraafplaats: 'BEGRAAFPLAATS',
  Begroting: 'BEGROTING',
  Belastingen: 'BELASTINGEN',
  BetaaldatumsUitkering: 'BETAALDATUMS_UITKERING',
  Bevolking: 'BEVOLKING',
  Bevrijding: 'BEVRIJDING',
  BezwaarEnBeroep: 'BEZWAAR_EN_BEROEP',
  Bijstandsuitkering: 'BIJSTANDSUITKERING',
  BladerenOpruimen: 'BLADEREN_OPRUIMEN',
  Bomen: 'BOMEN',
  BouwenEnVerbouwen: 'BOUWEN_EN_VERBOUWEN',
  Bouwprojecten: 'BOUWPROJECTEN',
  Brandgevaar: 'BRANDGEVAAR',
  Brief: 'BRIEF',
  Buitengebied: 'BUITENGEBIED',
  Burgemeester: 'BURGEMEESTER',
  Chat: 'CHAT',
  Computer: 'COMPUTER',
  Computerregeling: 'COMPUTERREGELING',
  ContactGemeente: 'CONTACT_GEMEENTE',
  Cultuur: 'CULTUUR',
  Documenten: 'DOCUMENTEN',
  Duurzaamheid: 'DUURZAAMHEID',
  EconomieWerkInkomen: 'ECONOMIE_WERK_INKOMEN',
  Eenzaamheid: 'EENZAAMHEID',
  Eikenprocessie: 'EIKENPROCESSIE',
  ElektrischLaden: 'ELEKTRISCH_LADEN',
  ElektrischRijden: 'ELEKTRISCH_RIJDEN',
  Energietransitie: 'ENERGIETRANSITIE',
  Enquete: 'ENQUETE',
  Erfgoed: 'ERFGOED',
  Erfpacht: 'ERFPACHT',
  Evenementen: 'EVENEMENTEN',
  F1: 'F1',
  Fiets: 'FIETS',
  Geboorte: 'GEBOORTE',
  Gebruiker: 'GEBRUIKER',
  GebruikerCentraal: 'GEBRUIKER_CENTRAAL',
  GebruikerIngelogd: 'GEBRUIKER_INGELOGD',
  Gebruikersvraag: 'GEBRUIKERSVRAAG',
  Gegevenswoordenboek: 'GEGEVENSWOORDENBOEK',
  Geld: 'GELD',
  Geluid: 'GELUID',
  Gemeenteraad: 'GEMEENTERAAD',
  Gemeenteraadsvergadering: 'GEMEENTERAADVERGADERING',
  GemivaLocatie: 'GEMIVA_LOCATIE',
  Gezicht: 'GEZICHT',
  Gladheid: 'GLADHEID',
  Grafiek: 'GRAFIEK',
  Grofvuil: 'GROFVUIL',
  Herdenking: 'HERDENKING',
  Hond: 'HOND',
  Hondenbelasting: 'HONDENBELASTING',
  HoogWater: 'HOOG_WATER',
  Hoogbouw: 'HOOGBOUW',
  Horeca: 'HORECA',
  Horecavergunningen: 'HORECAVERGUNNINGEN',
  Huis: 'HUIS',
  HuisEnOmgeving: 'HUISENOMGEVING',
  HuiselijkGeweld: 'HUISELIJK_GEWELD',
  HulpHuishouden: 'HULP_HUISHOUDEN',
  HulpmiddelenVinden: 'HULPMIDDELEN_VINDEN',
  Idkaart: 'IDKAART',
  InEnOmUwHuis: 'IN_EN_OM_UW_HUIS',
  Informatie: 'INFORMATIE',
  InformatieEnBetalen: 'INFORMATIE_EN_BETALEN',
  Inkomen: 'INKOMEN',
  Inloggen: 'INLOGGEN',
  Inspraak: 'INSPRAAK',
  Isolatie: 'ISOLATIE',
  Jeugd: 'JEUGD',
  Kennis: 'KENNIS',
  Kerstbomen: 'KERSTBOMEN',
  KindEnFamilie: 'KIND_EN_FAMILIE',
  Klacht: 'KLACHT',
  Koningsdag: 'KONINGSDAG',
  KopenEnHuren: 'KOPEN_EN_HUREN',
  KopenEnVerkopen: 'KOPEN_EN_VERKOPEN',
  LaadStation: 'LAAD_STATION',
  Leerlingenvervoer: 'LEERLINGENVERVOER',
  LetOp: 'LET_OP',
  Liefdadigheid: 'LIEFDADIGHEID',
  Locatie: 'LOCATIE',
  Manege: 'MANEGE',
  Marktgelden: 'MARKTGELDEN',
  Meeuwenoverlast: 'MEEUWENOVERLAST',
  Melding: 'MELDING',
  MeldingOmgevallenBoom: 'MELDING_OMGEVALLEN_BOOM',
  MeldingOpenbareRuimte: 'MELDING_OPENBARE_RUIMTE',
  MeldingStraatverlichting: 'MELDING_STRAATVERLICHTING',
  Milieuzone: 'MILIEUZONE',
  Mobiliteit: 'MOBILITEIT',
  MonitorAgrofood: 'MONITOR_AGROFOOD',
  MonitorDuurzaamheid: 'MONITOR_DUURZAAMHEID',
  MonitorSociaal: 'MONITOR_SOCIAAL',
  MonitorVirus: 'MONITOR_VIRUS',
  MonitorWoningmarkt: 'MONITOR_WONINGMARKT',
  Monument: 'MONUMENT',
  MonumentWoning: 'MONUMENT_WONING',
  Museum: 'MUSEUM',
  NatuurLandschap: 'NATUUR_LANDSCHAP',
  Nieuwsbrief: 'NIEUWSBRIEF',
  Omgeving: 'OMGEVING',
  Omgevingsvergunning: 'OMGEVINGSVERGUNNING',
  Omgevingsvisie: 'OMGEVINGSVISIE',
  OmgevingsvisieDocument: 'OMGEVINGSVISIE_DOCUMENT',
  Onderhoud: 'ONDERHOUD',
  Ondernemen: 'ONDERNEMEN',
  Onderscheidingen: 'ONDERSCHEIDINGEN',
  Onderwijs: 'ONDERWIJS',
  OnderwijsBasis: 'ONDERWIJS_BASIS',
  OnderwijsHoger: 'ONDERWIJS_HOGER',
  OnderwijsVoortgezet: 'ONDERWIJS_VOORTGEZET',
  OntheffingMilieuzone: 'ONTHEFFING_MILIEUZONE',
  Openingstijden: 'OPENINGSTIJDEN',
  OpeningstijdenWinkels: 'OPENINGSTIJDEN_WINKELS',
  OverDeGemeente: 'OVER_DE_GEMEENTE',
  OverDeStad: 'OVER_DE_STAD',
  Overlijden: 'OVERLIJDEN',
  Parkeerkosten: 'PARKEERKOSTEN',
  Parkeerplattegrond: 'PARKEERPLATTEGROND',
  Parkeervergunning: 'PARKEERVERGUNNING',
  ParkeervoorzieningGehandicapten: 'PARKEERVOORZIENING_GEHANDICAPTEN',
  Parkeren: 'PARKEREN',
  ParkerenBedrijven: 'PARKEREN_BEDRIJVEN',
  Participatie: 'PARTICIPATIE',
  ParticipatieCampagne: 'PARTICIPATIE_CAMPAGNE',
  ParticipatieChecklist: 'PARTICIPATIE_CHECKLIST',
  ParticipatieLike: 'PARTICIPATIE_LIKE',
  ParticipatiePitch: 'PARTICIPATIE_PITCH',
  ParticipatiePlan: 'PARTICIPATIE_PLAN',
  ParticipatieUitvoering: 'PARTICIPATIE_UITVOERING',
  Paspoort: 'PASPOORT',
  PaspoortIdkaartGecombineerd: 'PASPOORT_ID_KAART_GECOMBINEERD',
  PaspoortIdkaartGecombineerdInternationaal: 'PASPOORT_ID_KAART_GECOMBINEERD_INTERNATIONAAL',
  PaspoortInternationaal: 'PASPOORT_INTERNATIONAAL',
  Politiek: 'POLITIEK',
  Presentatie: 'PRESENTATIE',
  Prijskaartje: 'PRIJSKAARTJE',
  RaadEnCollege: 'RAAD_EN_COLLEGE',
  Reclame: 'RECLAME',
  Reclamebelasting: 'RECLAME_BELASTING',
  Recreatie: 'RECREATIE',
  RegelingLaagInkomen: 'REGELING_LAAG_INKOMEN',
  Rijbewijs: 'RIJBEWIJS',
  Riool: 'RIOOL',
  Rioolheffing: 'RIOOL_HEFFING',
  Rioolwerkzaamheden: 'RIOOL_WERKZAAMHEDEN',
  RoerendeZaakbelasting: 'ROERENDE_ZAAK_BELASTING',
  Rolstoel: 'ROLSTOEL',
  Schoolkostenregeling: 'SCHOOLKOSTEN_REGELING',
  Sinterklaas: 'SINTERKLAAS',
  SociaalZorgWelzijn: 'SOCIAAL_ZORG_WELZIJN',
  Speeltuin: 'SPEELTUIN',
  Sport: 'SPORT',
  SportCultureleActiviteit: 'SPORT_CULTURELE_ACTIVITEIT',
  SportkledingMuziekinstrumenten: 'SPORTKLEDING_MUZIEKINSTRUMENTEN',
  StationSneltrein: 'STATION_SNEL_TREIN',
  StationStoptrein: 'STATION_STOP_TREIN',
  Stookverbod: 'STOOKVERBOD',
  Strand: 'STRAND',
  Subsidie: 'SUBSIDIE',
  TemperatuurMelding: 'TEMPERATUUR_MELDING',
  Thuiswerken: 'THUISWERKEN',
  Toegankelijkheid: 'TOEGANKELIJKHEID',
  Toeslag: 'TOESLAG',
  TrouwenEnGeregistreerdPartnerschap: 'TROUWEN_EN_GEREGISTREERD_PARTNERSCHAP',
  Tuinbouw: 'TUINBOUW',
  Uittreksel: 'UITTREKSEL',
  UwGemeente: 'UW_GEMEENTE',
  UwWijk: 'UW_WIJK',
  Vacatures: 'VACATURES',
  Vaccinatie: 'VACCINATIE',
  Veerboot: 'VEERBOOT',
  VeiligeWijk: 'VEILIGE_WIJK',
  Vergaderen: 'VERGADEREN',
  VergaderenDigitaal: 'VERGADEREN_DIGITAAL',
  VergoedingEnergiekosten: 'VERGOEDING_ENERGIEKOSTEN',
  VergunningAlgemeen: 'VERGUNNING_ALGEMEEN',
  Verhuizen: 'VERHUIZEN',
  Verkeerslicht: 'VERKEERSLICHT',
  Verkiezingen: 'VERKIEZINGEN',
  Verslaving: 'VERSLAVING',
  Vervoersvoorziening: 'VERVOERSVOORZIENING',
  Virus: 'VIRUS',
  Vlag: 'VLAG',
  Vluchtelingenopvang: 'VLUCHTELINGENOPVANG',
  Voeding: 'VOEDING',
  Vrijwilligerswerk: 'VRIJWILLIGERSWERK',
  Vuurwerk: 'VUURWERK',
  Wandelen: 'WANDELEN',
  Welzijnswerk: 'WELZIJNSWERK',
  Werkzaamheden: 'WERKZAAMHEDEN',
  WieIsWie: 'WIE_IS_WIE',
  Wijkteam: 'WIJKTEAM',
  Windenergie: 'WINDENERGIE',
  Winkelen: 'WINKELEN',
  Winkelwagen: 'WINKELWAGEN',
  Wmo: 'WMO',
  Wolf: 'WOLF',
  WoningZoeken: 'WONING_ZOEKEN',
  WozWaarde: 'WOZ_WAARDE',
  ZelfbeheerTegel: 'ZELFBEHEER_TEGEL',
  ZelfstandigWonen: 'ZELFSTANDIG_WONEN',
  Zoeken: 'ZOEKEN',
  Zwemabonnement: 'ZWEMABONNEMENT',
  Zwemmen: 'ZWEMMEN',
};
